import { AbstractControl, ValidationErrors } from '@angular/forms';

const FORBIDDEN_PATTERN = /^\s*(INSERT|UPDATE|DELETE|TRUNCATE|DROP|CREATE|ALTER|REPLACE|MERGE|CALL|EXEC(?:UTE)?)\b/im;

function stripCommentsAndLiterals(sql: string): string {
  // Strip block comments /* ... */
  let cleaned = sql.replace(/\/\*[\s\S]*?\*\//g, '');
  // Strip line comments -- ...
  cleaned = cleaned.replace(/--[^\n]*/g, '');
  // Strip string literals to avoid false positives on keywords inside strings
  cleaned = cleaned.replace(/'(?:[^'\\]|\\.)*'/g, '');
  // Strip template tags {field ...} / {link ...} which may contain expressions
  cleaned = cleaned.replace(/\{[^}]+\}/g, '');
  return cleaned;
}

export function selectOnlyValidator(control: AbstractControl): ValidationErrors | null {
  const sql: string = control.value ?? '';
  if (!sql.trim()) {
    return null;
  }

  const cleaned = stripCommentsAndLiterals(sql);

  for (const statement of cleaned.split(';')) {
    if (statement.trim() && FORBIDDEN_PATTERN.test(statement)) {
      return { selectOnly: true };
    }
  }

  return null;
}
